"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
var of_1 = require("rxjs/observable/of");
var ejustice_notification_service_1 = require("../service/api/ejustice-notification.service");
var notification_logs_search_model_1 = require("../model/notification-logs-search.model");
var NotificationLogsSearchComponent = /** @class */ (function () {
    function NotificationLogsSearchComponent(notificationService) {
        this.notificationService = notificationService;
        this.destroy$ = new Subject_1.Subject();
        this._searchTerm$ = new Subject_1.Subject();
        this._isSearchOpen = false;
        this._sourceTypes$ = of_1.of([]);
        this._statuses$ = of_1.of([]);
        this.searchModel = new notification_logs_search_model_1.NotificationLogsSearchModel();
        this.searchChange = new core_1.EventEmitter();
    }
    NotificationLogsSearchComponent.prototype.ngOnInit = function () {
        this.subscribeToSearchChange();
        this._sourceTypes$ = this.notificationService.getNotificationSourcesTypes();
        this._statuses$ = this.notificationService.getNotificationStatuses();
    };
    NotificationLogsSearchComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    NotificationLogsSearchComponent.prototype.subscribeToSearchChange = function () {
        var _this = this;
        this._searchTerm$
            .pipe(operators_1.debounceTime(300), operators_1.distinctUntilChanged(), operators_1.takeUntil(this.destroy$))
            .subscribe(function (term) {
            _this.searchModel.term = term;
            _this.searchChange.emit(_this.searchModel);
        });
    };
    NotificationLogsSearchComponent.prototype.search = function (searchTerm) {
        this._searchTerm$.next(searchTerm.trim());
    };
    NotificationLogsSearchComponent.prototype.clearSearch = function (filterInputElement) {
        this._isSearchOpen = !this._isSearchOpen;
        filterInputElement.value = '';
        this.search('');
    };
    NotificationLogsSearchComponent.prototype.onSourceTypeChange = function (typeId) {
        this.searchModel.sourceTypeId = typeId;
        this.searchChange.emit(this.searchModel);
    };
    NotificationLogsSearchComponent.prototype.onStatusChange = function (statusIds) {
        this.searchModel.statusIds = statusIds;
        this.searchChange.emit(this.searchModel);
    };
    Object.defineProperty(NotificationLogsSearchComponent.prototype, "isSearchOpen", {
        get: function () {
            return this._isSearchOpen;
        },
        set: function (value) {
            this._isSearchOpen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationLogsSearchComponent.prototype, "sourceTypes$", {
        get: function () {
            return this._sourceTypes$;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationLogsSearchComponent.prototype, "statuses$", {
        get: function () {
            return this._statuses$;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], NotificationLogsSearchComponent.prototype, "searchChange", void 0);
    NotificationLogsSearchComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-notification-logs-search',
            template: require('./notification-logs-search.component.html'),
            styles: [require('./notification-logs-search.component.css')]
        }),
        __metadata("design:paramtypes", [ejustice_notification_service_1.EjusticeNotificationService])
    ], NotificationLogsSearchComponent);
    return NotificationLogsSearchComponent;
}());
exports.NotificationLogsSearchComponent = NotificationLogsSearchComponent;
//# sourceMappingURL=notification-logs-search.component.js.map